import { useMemo } from 'react'

const ChartWrapper = ({ type, chartData = [], chartWidth, chartHeight, totalSeconds }) => {
    
    const getWavePoints = (data, width = 240, height = 100, seconds) => {
        const sliced = data.slice(0, seconds * 500);
        if (sliced.length === 0) return '';
        // 데이터의 최대값과 최소값 계산
        const minVal = Math.min(...sliced);
        const maxVal = Math.max(...sliced);
        const range = maxVal - minVal;
        
        // 범위가 0인 경우 처리 (모든 값이 같은 경우)
        if (range === 0) {
            const y = height / 2;
            return sliced.map((_, idx) => {
                const x = (width / (sliced.length - 1)) * idx;
                return `${x},${y}`;
            }).join(' ');
        }
        
        const stepX = width / (sliced.length - 1);
        
        return sliced.map((val, idx) => {
            const x = idx * stepX;
            // 값을 0~height 범위로 정규화 (y축은 위쪽이 0이므로 뒤집어야 함)
            const normalizedVal = (val - minVal) / range;
            const y = height - (normalizedVal * height);
            return `${x},${y}`;
        }).join(' ');
    };

    const wavePoints = useMemo(() => {
        return getWavePoints(chartData || [], chartWidth, chartHeight, totalSeconds);
    }, [chartData, chartWidth, chartHeight, totalSeconds]);

    return (
        <div className="flex-1 relative">
            <svg className="w-full h-full" width="100%" height="100%" viewBox={`0 0 ${chartWidth} ${chartHeight}`}>
                <polyline
                    points={wavePoints}
                    fill="none"
                    stroke="#3DFF3D"
                    strokeWidth={1}
                />
            </svg>
            <div className="absolute top-0 left-[10px]" style={{ fontFamily: 'Roboto', fontSize: 16, color: '#3DFF3D' }}>{type}</div>
        </div>
    )
}

export default ChartWrapper